import React, { useState, useEffect } from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import Skills from "./skills/Skills";
import ExperienceAccordion from "./experienceAccordion/ExperienceAccordion.js";
import Educations from "./education/Educations";
import Certifications from "./certifications/Certifications";
import EducationImg from "../pages/education/EducationImg";
import ProjectShowcase from "../components/projectShowcase/ProjectShowcase";
import ContactForm from "../components/contactForm/ContactForm";
import Footer from "../components/footer/Footer";
import Splash from "../pages/splash/Splash";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";
import {
  settings,
  experience,
  projects,
} from "../portfolio.js";
import { Fade } from "react-reveal";
import "../pages/experience/Experience.css";
import "../pages/education/EducationComponent.css";
import "../pages/projects/Projects.css";

const SECTIONS = ["home", "experience", "projects", "education", "contact"];

export default function Main(props) {
  const [showSplash, setShowSplash] = useState(settings.isSplash);
  const [activeSection, setActiveSection] = useState("home");
  const { lang } = useLanguage();
  const t = translations[lang];
  const theme = props.theme;

  useEffect(() => {
    if (showSplash) return;

    function onScroll() {
      const headerEl = document.querySelector(
        ".header-container-light, .header-container-dark"
      );
      const headerHeight = headerEl ? headerEl.offsetHeight : 70;
      const scrollY = window.scrollY + headerHeight + 10;

      let current = "home";
      for (const id of SECTIONS) {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= scrollY) current = id;
      }
      setActiveSection(current);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [showSplash]);

  if (showSplash) {
    return <Splash theme={theme} onComplete={() => setShowSplash(false)} />;
  }

  const localizedProjects = projects.data.map((repo, i) => ({
    ...repo,
    description: t.projects.descriptions[i] ?? repo.description,
  }));

  return (
    <div>
      <Header
        theme={theme}
        setTheme={props.setTheme}
        activeSection={activeSection}
      />

      <section id="home" key={lang}>
        <Greeting theme={theme} />
        <Skills theme={theme} />
      </section>

      <section id="experience" className="experience-main">
        <div className="basic-experience">
          <Fade bottom duration={2000} distance="40px">
            <div className="experience-heading-div">
              <div className="experience-heading-text-div">
                <h1
                  className="experience-heading-text"
                  style={{ color: theme.text }}
                >
                  {t.experience.title}
                </h1>
                <h3
                  className="experience-heading-sub-text"
                  style={{ color: theme.text }}
                >
                  {t.experience.subtitle}
                </h3>
                <p
                  className="experience-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {t.experience.description}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        <ExperienceAccordion sections={experience["sections"]} theme={theme} />
      </section>

      <section id="projects" className="projects-main">
        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {t.projects.title}
                </h1>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {t.projects.description}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        <ProjectShowcase repos={localizedProjects} theme={theme} />
      </section>

      <section id="education" className="education-main">
        <div className="basic-education">
          <Fade bottom duration={2000} distance="40px">
            <div className="heading-div">
              <div className="heading-img-div">
                <EducationImg theme={theme} />
              </div>
              <div className="heading-text-div">
                <h1 className="heading-text" style={{ color: theme.text }}>
                  {t.education.heading}
                </h1>
                <h3 className="heading-sub-text" style={{ color: theme.text }}>
                  {t.education.subHeading}
                </h3>
                <p
                  className="experience-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {t.education.description}
                </p>
              </div>
            </div>
          </Fade>
          <Educations theme={props.theme} />
          <Certifications theme={props.theme} />
        </div>
      </section>

      <section id="contact">
        <ContactForm theme={theme} />
      </section>

      <Footer theme={props.theme} />
    </div>
  );
}
